export default __webpack_public_path__ + "static/media/bninidjaxxx-color.1fe1eed3.svg";